import React from "react";
import QuestionnaireVersions from "./QuestionnaireVersions"; // Adjust the import path as needed
import "../../../css/QuestionnaireVersions.css";

const HistoricalAndHealthPage: React.FC = () => {
  return (
    <div>
      <h1 style={{color:'#00a8a8', fontSize:'24px'}}>Questionnaire Management</h1>

      {/* --- Use the component for the 'Health' category --- */}
      {/* <QuestionnaireVersions 
        categorySlug="health" 
        categoryTitle="Health" 
      /> */}

      {/* --- Use the exact same component for the 'Historical' category --- */}
      <QuestionnaireVersions 
        categorySlug="historical" 
        categoryTitle="Historical" 
      />
    </div>
  );
};

export default HistoricalAndHealthPage;
